import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type LinkProps = Components<Omit<Theme, 'components'>>['MuiLink'];

const getMuiLink = (): LinkProps => ({
  defaultProps: {
    underline: 'hover',
  },
});

export default getMuiLink;
